import $ from 'jquery'

$(document).ready(function () {
  initSprintraceSpeakerAccordion()
})

/**
 * Get items-per-row from a grid container (data-items-per-row).
 * @param {jQuery} $grid
 * @returns {number}
 */
function getGridItemsPerRow($grid) {
  const raw = $grid.data('items-per-row')
  const n = parseInt(raw, 10)
  return Number.isFinite(n) && n >= 1 ? n : 1
}

/**
 * Get all speaker accordion elements in the same row as $accordion within $grid.
 * @param {jQuery} $grid
 * @param {jQuery} $accordion - one .dhsv_vc_sprintrace_speaker_accordion
 * @returns {jQuery}
 */
function getAccordionsInSameRow($grid, $accordion) {
  const itemsPerRow = getGridItemsPerRow($grid)
  const $children = $grid.children('.dhsv_vc_sprintrace_speaker_accordion')
  const index = $children.index($accordion)
  if (index < 0) return $accordion
  const rowStart = Math.floor(index / itemsPerRow) * itemsPerRow
  const rowEnd = rowStart + itemsPerRow
  return $children.slice(rowStart, rowEnd)
}

function setAccordionOpen($accordion, open) {
  const $item = $accordion.find('.sprintrace-speaker-accordion')
  const $toggle = $item.find('.sprintrace-speaker-accordion__toggle')
  const $content = $item.find('.sprintrace-speaker-accordion__content')
  if (open) {
    $content.slideDown(300)
    $item.addClass('is-open')
    $toggle.attr('aria-expanded', 'true')
  } else {
    $content.slideUp(300)
    $item.removeClass('is-open')
    $toggle.attr('aria-expanded', 'false')
  }
}

function initSprintraceSpeakerAccordion() {
  $('.dhsv_vc_sprintrace_speaker_accordion').each(function () {
    const $accordion = $(this)
    const $item = $accordion.find('.sprintrace-speaker-accordion')
    const $toggle = $item.find('.sprintrace-speaker-accordion__toggle')
    const $content = $item.find('.sprintrace-speaker-accordion__content')

    // Initially hide content
    $content.slideUp(0)
    $item.removeClass('is-open')
    $toggle.attr('aria-expanded', 'false')

    // Toggle on click
    $toggle.on('click', function (e) {
      e.preventDefault()
      const isOpen = $item.hasClass('is-open')
      const $grid = $accordion.closest('.dhsv_vc_sprintrace_speaker_accordion_grid')

      if ($grid.length) {
        // Inside grid: sync all accordions in the same row
        const $sameRow = getAccordionsInSameRow($grid, $accordion)
        const open = !isOpen
        $sameRow.each(function () {
          setAccordionOpen($(this), open)
        })
      } else {
        // Standalone: toggle only this accordion
        setAccordionOpen($accordion, !isOpen)
      }
    })
  })
}

